import $ from "jquery";

const loadMore = (e, articleList) => {
    const button = e.target || e;
    const data = JSON.parse($(button).attr("data-request"));
    const preloaded = $(articleList).find(".js-preloaded");

    for (let i = 0; i < $(preloaded).length; i++) {
        let card = preloaded[i];
        $(card).removeClass("previous-projects__item--preloaded js-preloaded");
    }

    $.ajax({
        url: "/wp/wp-admin/admin-ajax.php",
        type: "post",
        contentType: "application/x-www-form-urlencoded",
        data: {
            action: "load_posts",
            data: JSON.stringify(data),
        },

        success: function callback(result) {
            if (data.page_num) {
                data.page_num += 1;
                $(button).attr("data-request", JSON.stringify(data));
            }

            if (result) {
                articleList.insertAdjacentHTML("beforeend", result);
            } else {
                $(button).attr("disabled", "disabled");
                $(button).attr("aria-disabled", "true");
            }
        },
    });

    //move focus to first element in new list
    const articles = $(articleList).children();
    const postsPerPage = data.posts_per_page;
    const a11yIndex =
        (Math.floor(articles.length / postsPerPage) - 1) * postsPerPage;
    const link = $(articles[a11yIndex]).find("a");

    if (e.target) {
        $(link).focus();
    }
};

const initShowMoreArticles = (el) => {
    const articleList = el;
    const loadMoreButton = $(".js-load-more-button");

    //preload first ajax request:
    loadMore(loadMoreButton, articleList);

    $(loadMoreButton).on("click", function loadClick(e) {
        loadMore(e, articleList);
    });
};

export default initShowMoreArticles;
